import { makeStyles, Table, TableBody, TableCell, TableContainer, TableRow } from '@material-ui/core';
import { LenderName, PaymentMethodType } from '@nemuru-eng/js-api-client';
import { Fragment, ReactNode } from 'react';

import { OrchestrationTableRow } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/OrchestrationTableRow';
import { OrchestrationRow } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/OrchestrationRow';
import { CustomHeader } from '@/components/shared/components/CustomTable/CustomHeader';
import { useDefaultTable } from '@/components/shared/hooks/useDefaultTable';
import { TableColumn } from '@/config/types';

const TABLE_ELEMENT_ID = 'lender-orchestration-table';

const COLUMNS: TableColumn[] = [
  { name: 'paymentMethodType', label: 'PAYMENT_METHOD' },
  { name: 'agents', label: 'AGENTS' },
  { name: 'strategy', label: 'LENDER_ORCHESTRATION_COLUMN_STRATEGY' },
  { name: 'mode', label: 'LENDER_ORCHESTRATION_COLUMN_MODE' },
  { name: 'stop', label: 'LENDER_ORCHESTRATION_COLUMN_STOP' },
  { name: 'ranking', label: 'LENDER_ORCHESTRATION_COLUMN_RANKING' },
  { name: 'actions', label: '', align: 'right', colWidth: '110px' },
];

const useStyles = makeStyles({
  editPanel: { width: 0, minWidth: '100%' },
});

interface OrchestrationTableProps {
  rows: OrchestrationRow[];
  lendersByPaymentMethodType: Partial<Record<PaymentMethodType, LenderName[]>>;
  canEdit: boolean;
  editingType: PaymentMethodType | null;
  onToggleEdit: (paymentMethodType: PaymentMethodType) => void;
  renderEditPanel: (row: OrchestrationRow) => ReactNode;
}

export const OrchestrationTable = ({
  rows,
  lendersByPaymentMethodType,
  canEdit,
  editingType,
  onToggleEdit,
  renderEditPanel,
}: OrchestrationTableProps) => {
  const { classes, stickyCellStyle } = useDefaultTable({ tableElementId: TABLE_ELEMENT_ID });
  const ownClasses = useStyles();

  const getColumns = () => {
    if (canEdit) return COLUMNS;

    return COLUMNS.filter((column) => column.name !== 'actions');
  };

  return (
    <TableContainer id={TABLE_ELEMENT_ID}>
      <Table>
        <CustomHeader tableProps={{ classes, stickyCellStyle }} columns={getColumns()} />
        <TableBody className={classes.root}>
          {rows.map((row) => (
            <Fragment key={row.paymentMethodType}>
              <OrchestrationTableRow
                row={row}
                lenderNames={lendersByPaymentMethodType[row.paymentMethodType] ?? []}
                canEdit={canEdit}
                editing={editingType === row.paymentMethodType}
                onToggleEdit={() => onToggleEdit(row.paymentMethodType)}
              />
              {editingType === row.paymentMethodType && (
                <TableRow>
                  <TableCell colSpan={COLUMNS.length}>
                    <div className={ownClasses.editPanel}>{renderEditPanel(row)}</div>
                  </TableCell>
                </TableRow>
              )}
            </Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
